export const omcOptions = [
  { value: "IOCL", label: "IOCL" },
  { value: "BPCL", label: "BPCL" },
  { value: "HPCL", label: "HPCL" },
  { value: "SUPERGAS", label: "SUPERGAS" },
  { value: "TOTALGAS", label: "TOTALGAS" },
  { value: "Gogas", label: "Gogas" },
];
export const wayOptions = [
  { label: "One Way", value: "one" },
  { label: "Two Way", value: "two" },
];
